export enum AlertType {
    INFO = 'INFO',
    WARNING = 'WARNING',
    SEVERE = 'SEVERE'
}
